"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBranchCircuitStatus = void 0;
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const types_1 = require("../../types");
const processAlertsByLocation_1 = require("../../utils/alerts/processAlertsByLocation");
const mapSeverityToStatus = (severity) => {
    switch (severity) {
        case types_1.SensorAlertSeverity.Critical:
        case types_1.SensorAlertSeverity.High:
            return types_1.SensorCardStatus.Error;
        case types_1.SensorAlertSeverity.Medium:
        case types_1.SensorAlertSeverity.Low:
            return types_1.SensorCardStatus.Poor;
        case types_1.SensorAlertSeverity.Info:
        default:
            return types_1.SensorCardStatus.Good;
    }
};
const useBranchCircuitStatus = ({ selectedHubId }) => {
    const { sensors } = (0, hooks_1.useSensors)(selectedHubId ?? undefined);
    const { fetchSensorAlerts } = (0, hooks_1.useSensorAlerts)();
    const [alertsPerLocation, setAlertsPerLocation] = (0, react_1.useState)(undefined);
    const branchCircuits = (0, react_1.useMemo)(() => {
        if (!alertsPerLocation) {
            return [];
        }
        console.log('Alerts Per Location:', alertsPerLocation);
        const powerSensors = sensors.filter((sensor) => sensor.type === types_1.SensorType.POWER);
        const branchCircuits = powerSensors
            .filter((sensor) => sensor.branchCircuits && sensor.branchCircuits.length > 0)
            .flatMap((sensor) => sensor.branchCircuits);
        const uniqueLocations = new Set(branchCircuits.map((circuit) => circuit.location).filter(Boolean));
        const items = Object.entries(alertsPerLocation)
            .filter(([location]) => uniqueLocations.has(location))
            .map(([location, alerts]) => {
            // Filter alerts to only consider electrical alerts defined in BranchCircuitAlertTypes
            const electricalAlerts = alerts.filter(alert => types_1.BranchCircuitAlertTypes.includes(alert.alertType));
            // Only use electrical alerts for status determination - if no electrical alerts exist, branch is healthy
            const status = electricalAlerts.length > 0
                ? mapSeverityToStatus(electricalAlerts[0].severity)
                : types_1.SensorCardStatus.Good;
            // Find the sensor that has a branch circuit with this location
            const correspondingSensor = powerSensors.find((sensor) => sensor.branchCircuits?.some((circuit) => circuit.location === location));
            return {
                location,
                status,
                alert: electricalAlerts.length > 0 ? electricalAlerts[0] : null,
                lastReported: correspondingSensor?.lastReported ?? null,
            };
        });
        return items;
    }, [alertsPerLocation]);
    const fetchAlerts = async () => {
        if (sensors.length === 0) {
            return [];
        }
        const alerts = await (0, processAlertsByLocation_1.processAlertsByLocation)(sensors, fetchSensorAlerts);
        setAlertsPerLocation(alerts);
    };
    (0, react_1.useEffect)(() => {
        fetchAlerts();
    }, [sensors, selectedHubId]);
    return { branchCircuits };
};
exports.useBranchCircuitStatus = useBranchCircuitStatus;
